import { useEffect } from "react";
import { useCadastrosBasicoController } from "./context/cadastros-basico-controller";
import { useCadastrosBasicoDispatch, useCadastrosBasicoState } from "./context/cadastros-basico-context";
import { ACTION_TYPES, FORM_TYPES } from "./context/cadastros-basico-reducer";
import { DataGrid } from '@mui/x-data-grid';
import { Button, Grid, InputLabel, OutlinedInput, Paper, SpeedDial } from "@mui/material";
import React from "react";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { CadastroBasicoDrawer } from "./components/cadastro-basico-drawer";
import SpeedDialIcon from '@mui/material/SpeedDialIcon';

export const CadastroBasico = ({ formType }: { formType: FORM_TYPES }) => {
    const { dataPaginatedListResponse, isLoadingData, dataSearchRequest } = useCadastrosBasicoState();
    const { onChangePagination, loadData, handleOnChange, getCollumnsGrid, clearFieldss } = useCadastrosBasicoController();
    const cadastrosBasicoDispatch = useCadastrosBasicoDispatch();
    useEffect(() => {
        (async () => {
            await loadData(dataSearchRequest, formType);
        })();
    }, [formType]);




    return (
        <React.Fragment>
            <CadastroBasicoDrawer formType={formType}></CadastroBasicoDrawer>
            <Grid item xs={12} md={12} lg={12}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Grid
                        container spacing={1.5}
                    >
                        <Grid
                            item
                            lg={8}
                            sm={8}
                            xl={8}
                        >
                            <InputLabel>Buscar por</InputLabel>
                            <OutlinedInput
                                inputProps={{ min: 0 }}
                                name="input-term"
                                size="small"
                                value={dataSearchRequest?.term}
                                defaultValue={dataSearchRequest?.term}
                                onChange={handleOnChange}
                                fullWidth

                            />
                        </Grid>

                        <Grid item lg={2}
                            sm={2}
                            xl={2} direction="row" justifyContent="flex-end"
                            sx={{
                                mt: 1,
                                display: 'flex',
                                flexDirection: "column",
                                justifyContent: "flex-end",
                                alignItems: "flex-end"
                            }}
                        >
                            <Button variant="contained" fullWidth size="small" onClick={async () => {
                                await loadData(dataSearchRequest, formType);
                            }} startIcon={<SearchIcon />}>Consultar</Button>
                        </Grid>
                        <Grid item lg={2}
                            sm={2}
                            xl={2} direction="row" justifyContent="flex-end"
                            sx={{
                                mt: 1,
                                display: 'flex',
                                flexDirection: "column",
                                justifyContent: "flex-end",
                                alignItems: "flex-end"
                            }}
                        >

                            <Button variant="outlined" fullWidth size="small" onClick={async () => {
                                await clearFieldss(formType);
                            }} startIcon={<ClearIcon />}>Limpar</Button>
                        </Grid>

                    </Grid>
                </Paper>
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{}}>
                <Paper

                    sx={{
                        p: 2,
                        minHeight: "500px",

                        display: 'flex',

                        flexDirection: 'column'
                    }}
                >
                    <DataGrid
                        rows={dataPaginatedListResponse.items}
                        columns={getCollumnsGrid(formType)}
                        pagination={true}
                        onPaginationModelChange={(e) => {
                            onChangePagination(formType, e.page, e.pageSize);
                        }}
                        hideFooterSelectedRowCount
                        disableRowSelectionOnClick
                        pageSizeOptions={[]}
                        sx={{
                            '& .MuiDataGrid-row': {
                                cursor: 'pointer',
                            },
                            '.MuiDataGrid-virtualScroller': {
                                overflowY: 'auto !important',
                                // example of maxHeight
                                maxHeight: '50vh !important',
                            },
                        }}
                        localeText={{
                            noRowsLabel: "Não foi encontrado resultados",
                            MuiTablePagination: {
                                labelDisplayedRows: ({ from, to, count, page }) =>
                                    `Página ${Number(page) === 0 ? 1 : Number(page) + 1} de ${count === 0 || dataPaginatedListResponse.pageSize === 0 ? 1 : Math.ceil(count / dataPaginatedListResponse.pageSize)} | Total de Registros: ${dataPaginatedListResponse.totalRecords}`,
                            }
                        }}
                        paginationModel={{ page: dataSearchRequest?.page, pageSize: dataPaginatedListResponse?.pageSize }}
                        rowCount={dataPaginatedListResponse.totalRecords}
                        paginationMode="server"
                        loading={isLoadingData}
                    />
                    <SpeedDial
                        ariaLabel="SpeedDial basic example"
                        sx={{ position: 'absolute', bottom: 16, right: 16 }}
                        onClick={() => {
                            cadastrosBasicoDispatch({
                                type: ACTION_TYPES.setDataRequest,
                                payload: {},
                            });
                            cadastrosBasicoDispatch({
                                type: ACTION_TYPES.setShowAddEdit,
                                payload: true,
                            });
                        }}
                        icon={<SpeedDialIcon />}
                    >
                    </SpeedDial>
                </Paper>
            </Grid>
        </React.Fragment>

    )
}